import { Component } from '@angular/core';
import { AppState } from '../../../../../app/app.global';
import { App,LoadingController,AlertController } from 'ionic-angular';
import { ProjectInfo } from '../detail/projectinfo';
import { HttpService } from '../../../../../providers/service/httpservice';
import { PROJECTLIST } from '../../../../../providers/config/serviceurl';
import { StorageService } from '../../../../../providers/service/storageservice';

@Component({
	selector: 'project-list',
  templateUrl: 'projectlist.html'
})

export class ProjectList {

	pageIndex = 1;
	pageNumber = 20;
	artsitems:any=[];
	scienceitems:any=[];
	public loading;
	user:any;
	params:any=[];
	count:any;
	
	constructor(public global: AppState,public appCtrl: App,private httpService:HttpService,
		private loadCtrl:LoadingController) {
			this.count = StorageService.getObj('xmcount');
			this.artsitems = StorageService.getObj('xmartsitems');
			this.scienceitems = StorageService.getObj('xmscienceitems');
			this.user = StorageService.getObj('currentUser');
			this.params = {'hd':this.user.hd};
			this.loadData(this.params);
	}
	
	getList(params){
		this.loading = this.loadCtrl.create({
			content: '加载中...',
		});
		this.httpService.post(PROJECTLIST,params).then(anyObj =>this.handleList(anyObj));
		this.loading.dismiss();//加载动画结束
	}
	
	//跳转详情
  openProjectDetail(item){
  		this.appCtrl.getRootNav().push(ProjectInfo,item);
  }
  
	//上拉加载
  loadMore(refresher){
		setTimeout(() => {
				this.pageIndex++;
				this.params = {'pageNo':this.pageIndex,'pageSize':this.pageNumber,'hd':this.user.hd};
				this.getList(this.params);
	      refresher.complete();
	  }, 500);
		
	}
  
  //下拉刷新
  doRefresh(refresher){
  	  setTimeout(() => {
    	 this.pageIndex = 1;
    	 this.params = {'pageNo':this.pageIndex,'pageSize':this.pageNumber,'hd':this.user.hd};
    	 this.artsitems = [];
    	 this.scienceitems = [];
    	 this.getList(this.params);
    	 refresher.complete();
  	  }, 1000);
  }
  
  loadData(params){
		this.loading = this.loadCtrl.create({
			content: '加载中...',
		});
		this.httpService.post(PROJECTLIST,params).then(anyObj =>this.handleList(anyObj));
	  this.loading.dismiss();//加载动画结束
		
	}
  
  handleList(obj:any){
  	if(obj){
  		var vk:any=[];
  		var lk:any=[];
  		this.count = obj.count;
  		StorageService.setObj("xmcount",this.count);
  		var length = obj.list.length;
  		if(this.artsitems == null){
  			this.artsitems = [];
  		}
  		if(this.scienceitems == null){
  			this.scienceitems = [];
  		}
  		for(var i=0;i<length;i++){
  			if(obj.list[i].sjly!=null&&obj.list[i].sjly=="文科"){
  				this.artsitems.push(obj.list[i]);
  				vk.push(obj.list[i]);
  			}else if(obj.list[i].sjly!=null&&obj.list[i].sjly=="理科"){
  				this.scienceitems.push(obj.list[i]);
  				lk.push(obj.list[i]);
  			}
  		}
  		//第一次加载数据的时候储存信息
  		if(this.pageIndex == 1){
  			this.artsitems = vk;
  			this.scienceitems = lk;
  			StorageService.setObj("xmartsitems",this.artsitems);
  			StorageService.setObj("xmscienceitems",this.scienceitems);
  		}
	}
  }
  
}


// WEBPACK FOOTER //
// ./src/pages/application/research/project/list/projectlist.ts